import React, { useContext, useEffect, useState } from "react";
import { Grid, Box } from "@material-ui/core";

import ValidatedInput from "../components/ValidatedInput";
import translate from "../i18n/Translator";
import { AppContext } from "./AppContext";

export default function TenantSwitch() {
    const context = useContext(AppContext);
    const platform = context.session!.accesses.findIndex((access) => access.tenant_id === "") >= 0;
    let id = [context.session?.tenant?.id, context.session?.customer?.id].filter(i => !!i).join("__");

    const [ids, setIds] = useState<string[]>([]);
    const [labels, setLabels] = useState<string[]>([]);

    const changeTenant = (_name: string, value: string, _: any) => {
        const tenant = context.session!.tenant;
        const segments = value.split("__");
        const tenantId = segments.length > 0 ? segments[0] : "";
        const customerId = segments.length > 1 ? segments[1] : undefined;

        if (tenant) {
            if (tenant.id === tenantId) {
                const customer = context.session?.customer;
                if (customer) {
                    if (customer.id === customerId) {
                        return;
                    }
                } else if (!customerId) {
                    return;
                }
            }
        } else if (!tenantId) {
            return;
        }

        context.onChangedTenant(tenantId, customerId);
    };

    useEffect(() => {
        if (context.session && context.session.accesses) {
            setIds(context.session.accesses.filter((access) => access.tenant_id !== "").map((access) => [access.tenant_id, access.customer_id].filter(i => !!i).join("__")));
            setLabels(context.session.accesses.filter((access) => access.tenant_id !== "").map((access) => [access.name, access.customer_name].filter(i => !!i).join(" - ")));
        }
    }, [context.session]);

    return (
        <Box pt={3} pb={1}>
            <Grid container justify="center">
                <Grid item xs={10}>
                    <ValidatedInput margin="dense" type="text" id="tenant_picker" name="tenant_picker" label={translate("app.switch") as string}
                        value={id} onValueChanged={changeTenant}
                        emptyOption={translate("app.title") as string} omitEmpty={!platform} variant="standard"
                        options={ids} optionLabels={labels} />
                </Grid>
            </Grid>
        </Box>
    );
}